import type { IOption } from '@axo/shared/ui/input/lib/RadioGroup/RadioGroupUI';
import { electricityFieldOptions } from './electricity';
import { waterFieldOptions } from './water';
import { heatingFieldOptions } from './heating';
import { insuranceFieldOptions } from './insurance';

export type AllExpensesOptions = {
  electricity: IOption[];
  water: IOption[];
  heating: IOption[];
  insurance: IOption[];
};

export const allExpensesOptions: AllExpensesOptions = {
  electricity: electricityFieldOptions.options,
  water: waterFieldOptions.options,
  heating: heatingFieldOptions.options,
  insurance: insuranceFieldOptions.options,
};
